// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"223ca8b6","453":"da096bef","817":"950d5e2b"}[chunkId] + ".chunk.js";
};